import { ColumnDef } from '@tanstack/react-table'
import { DataTable, DataTableProvider } from 'components/DataTable'
import styled from 'styled-components'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ContactsPreviewTable<T extends Record<string, any>>({
  data,
  columns,
}: {
  data: T[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: ColumnDef<T, any>[]
}) {
  return (
    <TableContainer>
      <DataTableProvider tableKey={'preview-successfull-imports'}>
        <DataTable
          autoLayout
          data={data}
          columns={columns}
          virtualizeRows={false}
        />
      </DataTableProvider>
    </TableContainer>
  )
}

const TableContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  overflow: hidden;
`
